import { BookingsConfig } from '../../../config';
import { Day } from '../../../helpers/Day';
import { IGymTimeSlotsRepository } from '../interfaces';

export class InMemoryGymTimeSlotsRepository implements IGymTimeSlotsRepository {
    public static testingSet: boolean = true;

    private gymTimeSlots: Day[] = [];

    public async createDefaultDoc(): Promise<void> {
        this.gymTimeSlots = BookingsConfig.generateDays(InMemoryGymTimeSlotsRepository.testingSet);
    }

    public async getAll(): Promise<Day[]> {
        return this.gymTimeSlots;
    }

    public async updateCache(): Promise<void> {
        throw new Error('Method not implemented.');
    }

  public async setOpenAllDayEveryDay(): Promise<void> {
    this.gymTimeSlots = BookingsConfig.generate24HourTimeSlots();
  }
}
